import React from 'react';
import { FullscreenLayout } from 'mapbox-demo-components'

import '@mapbox/mbx-assembly/dist/assembly.js';
import '@mapbox/mbx-assembly/dist/assembly.css'

function App() {
  return (
    <div className="App h-viewport-full">
      <FullscreenLayout headerProps={{
        title: 'Mapbox Developer Cheat Sheet'
      }}>
        <iframe height="100%" width="100%" src={process.env.PUBLIC_URL + '/developer-cheatsheet.html'}/>
      </FullscreenLayout>
    </div>
  );
}

export default App;
